import { Link } from "@tanstack/react-router";
import { Shield } from "lucide-react";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <div className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-hero text-primary-foreground">
                <Shield className="h-4 w-4" />
              </div>
              <span className="font-display text-base font-semibold">LendyTrack</span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              AI-powered consumer loan intelligence. Compare lenders, detect red flags, and borrow smarter.
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold">Product</div>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/lenders" className="hover:text-foreground">Lender search</Link></li>
              <li><Link to="/analyzer" className="hover:text-foreground">Loan analyzer</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold">Legal</div>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/terms" className="hover:text-foreground">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold">Company</div>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/faq" className="hover:text-foreground">Support FAQ</Link></li>
              <li><Link to="/status" className="hover:text-foreground">System status</Link></li>
              <li><Link to="/contact" className="hover:text-foreground">Contact us</Link></li>
              <li><a href="mailto:support@lendytrack.com" className="hover:text-foreground">support@lendytrack.com</a></li>
              <li className="pt-2">Oasis Media Group LLC</li>
            </ul>
          </div>

        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 text-xs text-muted-foreground md:flex-row">
          <p>© {year} LendyTrack. All rights reserved.</p>
          <p>An Oasis Media Group LLC Company</p>
        </div>
      </div>
    </footer>
  );
}
